// PDF閲覧機能のJavaScript

class SimpleEncryption {
  static key = 'JmEdJ2025PdfSecureKey123456789AB';

  static encrypt(productId) {
    let encrypted = '';
    for (let i = 0; i < productId.length; i++) {
      const keyChar = this.key.charCodeAt(i % this.key.length);
      const productChar = productId.charCodeAt(i);
      encrypted += String.fromCharCode(productChar ^ keyChar);
    }
    return btoa(encrypted).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
  }
}

// イベント委譲を使用して動的ボタンにも対応
document.addEventListener('click', function (event) {
  if (event.target.classList.contains('pdf-view-btn')) {
    event.preventDefault();
    event.stopPropagation();

    const productId = event.target.getAttribute('data-product-id');
    if (!productId) {
      showError('商品情報が取得できませんでした', event.target);
      return;
    }

    viewPdf(productId, event.target);
  }
});

async function viewPdf(productId, buttonElement) {
  const originalText = buttonElement.textContent;
  buttonElement.textContent = '読み込み中...';
  buttonElement.disabled = true;

  hideError(buttonElement);

  try {
    const encryptedProductId = SimpleEncryption.encrypt(productId);
    const apiUrl = `/apps/jmedj_ext/api/pdf/view?encrypted_product_id=${encodeURIComponent(encryptedProductId)}`;

    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: { Accept: 'application/pdf, application/json' },
      credentials: 'same-origin',
    });

    if (!response.ok) {
      let errorMessage = '不明なエラーが発生しました';
      try {
        const errorData = await response.json();
        errorMessage = errorData.error || errorMessage;
      } catch (e) {
        const errorText = await response.text();
        errorMessage = errorText || errorMessage;
      }
      showError(errorMessage, buttonElement);
      return;
    }

    const contentType = response.headers.get('Content-Type');

    if (contentType && contentType.includes('application/pdf')) {
      const pdfBlob = await response.blob();
      const pdfUrl = URL.createObjectURL(pdfBlob);
      const newWindow = window.open(pdfUrl, '_blank');

      if (!newWindow) {
        showError('ポップアップがブロックされています', buttonElement);
        URL.revokeObjectURL(pdfUrl);
        return;
      }

      setTimeout(() => {
        URL.revokeObjectURL(pdfUrl);
      }, 300000); // 5分 (300秒)
    } else {
      showError('PDFファイルの読み込みに失敗しました', buttonElement);
    }
  } catch (error) {
    showError('通信エラーが発生しました', buttonElement);
  } finally {
    buttonElement.textContent = originalText;
    buttonElement.disabled = false;
  }
}

function showError(message, buttonElement) {
  // ボタンの近くのエラー要素を探す
  let errorDiv = buttonElement.parentElement.querySelector('.pdf-error-message');

  // 見つからない場合は、ページ全体から探す
  if (!errorDiv) {
    errorDiv = document.querySelector('.pdf-error-message');
  }

  if (errorDiv) {
    errorDiv.textContent = message;
    errorDiv.style.display = 'block';

    setTimeout(() => {
      hideError(buttonElement);
    }, 5000);
  } else {
    // フォールバック: アラートで表示
    alert(`エラー: ${message}`);
  }
}

function hideError(buttonElement) {
  // ボタンの近くのエラー要素を探す
  let errorDiv = buttonElement.parentElement.querySelector('.pdf-error-message');

  // 見つからない場合は、ページ全体から探す
  if (!errorDiv) {
    errorDiv = document.querySelector('.pdf-error-message');
  }

  if (errorDiv) {
    errorDiv.style.display = 'none';
    errorDiv.textContent = '';
  }
}
